// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 35em;
}
.navigation_logo > img {
  display: block;
  width: 12em !important;
  height: 12em !important;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  /* background-color: white; */
  text-align: center;
}
.navigation_cart {
  position: relative;
  display: flex;
  flex-direction: row;
  text-align: end;
  color: #ffc917;
  font-size: 1.5em;
  cursor: pointer;
}
.navigation_cart_count {
  font-size: 0.5em;
  position: absolute;
  color: #f3f3f3;
  border: 1px solid #ffc917;
  border-radius: 4px;
  top: -16px;
  right: -32px;
  width: 2em;
  padding: 0.2em;
  text-align: center;
}

header {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 115px;
  z-index: 10;
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/123024/menutexture.png);
  background-position: center top;
  background-size: auto 200px;
  background-repeat: repeat-x;
}

header .inner {
  max-width: 1060px;
  margin: 0 auto;
  display: flex;
  height: 70px;
  align-items: center;
  justify-content: center;
  position: relative;
}

header .logo {
  display: block;
  width: 12em !important;
  height: 12em !important;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  /* background-color: white; */
  text-align: center;
}

img {
  width: 100%;
  height: 100%;
}

header nav {
  display: flex;
  flex-direction: row;
}

header nav a {
  font-family: "Varela Round";
  font-size: 12px;
  color: #8c8c8e;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-decoration: none;
  margin: 0 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

header nav a.active,
header nav a:hover {
  color: white;
}

header .burger {
  display: block;
  position: relative;
  top: -6px;
  padding-left: 30px;
}

header .burger:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 2px;
  background: white;
  box-shadow: 0 12px 0 0 white, 0 6px 0 0 white;
}

header .donate-link {
  width: 72px;
  text-align: center;
  position: absolute;
  right: 10px;
  top: 27px;
  font-family: "Varela Round";
  font-size: 12px;
  color: white;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-decoration: none;
  padding-bottom: 6px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
}

.mobileNav_container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10em;
}

.mobileNav {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 70%;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  z-index: 999999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2em;
}
.mobileNav a {
  font-size: 1.5em;
  text-transform: uppercase;
  letter-spacing: 3px;
  text-decoration: none;
}

@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#n {
  position: absolute;
  top: 90%;
  left: -28%;
  right: 0;
  height: 5vw;
  width: 20%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 15;
}

#n li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#n li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#n li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#n li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#n li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#n li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#n li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#n li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#a {
  position: absolute;
  top: 90%;
  left: 2%;
  right: 0%;
  height: 5vw;
  width: 20%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#a li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#a li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#a li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#a li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#a li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#a li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#v {
  position: absolute;
  top: 90%;
  left: 30%;
  right: 0%;
  height: 5vw;
  width: 20%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#v li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#v li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#v li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#v li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#v li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#v li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

/* <reset-style> ============================ */
button {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
}

/* ============================ */
/* <style for bg> ======== */
.background {
  border-radius: 16px;
  border: 1px solid #1a1a1a;
  background: transparent;
  border: 1px solid #ffc917;
  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  justify-self: center;
  position: relative;
  z-index: 10;
}

/* <style for menu__icon> ======== */
.menu__icon {
  width: 32px;
  height: 32px;
  padding: 4px;
}

.menu__icon span {
  display: block;
  width: 100%;
  height: 0.125rem;
  border-radius: 2px;
  background-color: #ffc917;
  box-shadow: 0 0.5px 2px 0 hsla(0, 0%, 0%, 0.2);
  transition: background-color 0.4s;
  position: relative;
}

.menu__icon span + span {
  margin-top: 0.375rem;
}

.menu__icon span:nth-child(1) {
  animation: ease 0.8s menu-icon-top-2 forwards;
}

.menu__icon span:nth-child(2) {
  animation: ease 0.8s menu-icon-scaled-2 forwards;
}

.menu__icon span:nth-child(3) {
  animation: ease 0.8s menu-icon-bottom-2 forwards;
}

.menu__icon:hover span:nth-child(1) {
  animation: ease 0.8s menu-icon-top forwards;
}

.menu__icon:hover span:nth-child(2) {
  animation: ease 0.8s menu-icon-scaled forwards;
}

.menu__icon:hover span:nth-child(3) {
  animation: ease 0.8s menu-icon-bottom forwards;
  background-color: #050505;
}

@keyframes menu-icon-top {
  0% {
    top: 0;
    transform: rotate(0);
  }
  50% {
    top: 0.5rem;
    transform: rotate(0);
  }
  100% {
    top: 0.5rem;
    transform: rotate(45deg);
  }
}
@keyframes menu-icon-top-2 {
  0% {
    top: 0.5rem;
    transform: rotate(45deg);
  }
  50% {
    top: 0.5rem;
    transform: rotate(0);
  }
  100% {
    top: 0;
    transform: rotate(0);
  }
}
@keyframes menu-icon-bottom {
  0% {
    bottom: 0;
    transform: rotate(0);
  }
  50% {
    bottom: 0.5rem;
    transform: rotate(0);
  }
  100% {
    bottom: 0.5rem;
    transform: rotate(135deg);
  }
}
@keyframes menu-icon-bottom-2 {
  0% {
    bottom: 0.5rem;
    transform: rotate(135deg);
  }
  50% {
    bottom: 0.5rem;
    transform: rotate(0);
  }
  100% {
    bottom: 0;
    transform: rotate(0);
  }
}
@keyframes menu-icon-scaled {
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes menu-icon-scaled-2 {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@media (min-width: 390px) {
  .navigation {
    gap: 0.5em;
  }
  header .burger {
    display: block;
    position: relative;
    top: -6px;
    right: -40%;
    padding-left: 0;
  }
  header .logo img {
    width: 3em;
    height: 3em;
  }
  header .logo {
    left: 0;
    top: 10%;
  }
  .navigation_company {
    display: none;
  }
  #slider img {
    width: 10em;
    height: 60%;
    object-position: center center;
    object-fit: cover;
    image-rendering: auto;
    z-index: 6;
  }
}
@media (min-width: 768px) {
  header .burger {
    display: none;
  }
  .navigation_logo {
    flex: 1 1;
  }
  .navigation_logo > img {
    width: 5em !important;
    height: 5em !important;
  }
  header .logo img {
    width: 5em;
    height: 5em;
  }
  header .logo {
    left: 0%;
  }
  .navigation_company {
    display: block;
  }
  #slider img {
    width: 10em;
    height: 100%;
    object-position: center center;
    object-fit: cover;
    image-rendering: auto;
    z-index: 6;
  }
  #n,
  #a,
  #v {
    top: 70%;
  }
  #n li,
  #a li,
  #v li {
    font-size: 1.2em;
  }
}
@media (min-width: 1024px) {
  .navigation {
    gap: 34em;
  }
  .navigation_logo {
    flex: 1 1;
  }
  .navigation_logo > img {
    width: 12em;
    height: 12em;
  }
  header .burger {
    display: none;
  }
  header .logo img {
    width: 100%;
    height: 100%;
  }
  .navigation_company {
    display: block;
  }
  #slider img {
    width: 10em;
    height: 100%;
    object-position: center center;
    object-fit: cover;
    image-rendering: auto;
    z-index: 6;
  }
  #n,
  #a,
  #v {
    top: 70%;
  }
  #n li,
  #a li,
  #v li {
    font-size: 1.8em;
  }
  #a {
    left: 7%;
  }
  #v {
    left: 40%;
  }
}
@media (min-width: 1280px) {
  header .burger {
    display: none;
  }
  header .logo img {
    width: 100%;
    height: 100%;
  }
  .navigation_company {
    display: block;
  }
  #slider img {
    width: 10em;
    height: 100%;
    object-position: center center;
    object-fit: cover;
    image-rendering: auto;
    z-index: 6;
  }
  #n,
  #a,
  #v {
    top: 90%;
  }
  #n li,
  #a li,
  #v li {
    font-size: 1.5vw;
  }
  #a {
    left: 2%;
  }
  #v {
    left: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navigation/styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AADF;AAQI;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AANN;AAcE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,cCpCO;EDqCP,gBAAA;EACA,eAAA;AAbJ;AAeI;EACE,gBAAA;EACA,kBAAA;EACA,cCtCM;EDuCN,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AAbN;;AAkBA;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,0FAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;AAfF;;AAiBA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAdF;;AAgBA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;AAbF;;AAeA;EACE,aAAA;EACA,mBAAA;AAZF;;AAcA;EACE,2BAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAXF;;AAcA;;EAEE,YAAA;AAXF;;AAcA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AAXF;;AAaA;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,6CAAA;AAVF;;AAaA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iDAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAVF;AAYE;EAEE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;AAXJ;;AAeA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAZF;EAeA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbF;EAeA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbF;EAeA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbF;EAeA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbF;EAeA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbF;EAeA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbF;EAeA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAbF;EAeA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbF;EAeA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAbF;AACF;AAgBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAdF;EAiBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfF;EAiBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfF;EAiBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfF;EAiBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfF;EAiBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfF;EAiBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfF;EAiBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAfF;EAiBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAfF;EAiBA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAfF;EAkBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhBF;EAkBA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAhBF;EAmBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjBF;EAmBA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EAjBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlBF;EAoBA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAlBF;AACF;AAqBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;EAsBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApBF;AACF;AAuBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArBF;EAwBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBF;EAwBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBF;EAwBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBF;EAwBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBF;EAwBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBF;EAwBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBF;EAwBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBF;EAwBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBF;EAwBA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAtBF;EAwBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBF;EAwBA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtBF;AACF;AAyBA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvBF;EA0BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBF;EA0BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBF;EA0BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBF;EA0BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBF;EA0BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBF;EA0BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBF;EA0BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBF;EA0BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBF;EA0BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxBF;EA0BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBF;EA0BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxBF;AACF;AA2BA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzBF;EA4BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BF;EA4BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BF;EA4BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BF;EA4BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BF;EA4BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BF;EA4BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BF;EA4BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BF;EA4BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BF;EA4BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1BF;EA4BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BF;EA4BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1BF;AACF;AA6BA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA3BF;EA8BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BF;EA8BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BF;EA8BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BF;EA8BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BF;EA8BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BF;EA8BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BF;EA8BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BF;EA8BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BF;EA8BA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA5BF;EA8BA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5BF;EA8BA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EA5BF;AACF;AAgCA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AA9BF;;AAgCA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AA7BF;;AA+BA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA5BF;;AA8BA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA3BF;;AA6BA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AA1BF;;AA4BA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAzBF;;AA2BA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAxBF;;AA0BA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAvBF;;AAyBA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAtBF;;AAwBA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AArBF;;AAuBA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AApBF;;AAsBA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAnBF;;AAqBA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAlBF;;AAoBA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAjBF;;AAmBA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAhBF;;AAkBA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AAfF;;AAiBA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAdF;;AAgBA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAbF;;AAeA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAZF;;AAcA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAXF;;AAaA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAVF;;AAcA,+CAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;AAXF;;AAaA,iCAAA;AACA,4BAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,8CAAA;EACA,mCAAA;UAAA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AAXF;;AAcA,oCAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAXF;;AAcA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBC11BS;ED21BT,8CAAA;EACA,iCAAA;EACA,kBAAA;AAXF;;AAcA;EACE,oBAAA;AAXF;;AAcA;EACE,6CAAA;AAXF;;AAcA;EACE,gDAAA;AAXF;;AAcA;EACE,gDAAA;AAXF;;AAcA;EACE,2CAAA;AAXF;;AAcA;EACE,8CAAA;AAXF;;AAcA;EACE,8CAAA;EACA,yBCv3BU;AD42BZ;;AAcA;EACE;IACE,MAAA;IACA,oBAAA;EAXF;EAcA;IACE,WAAA;IACA,oBAAA;EAZF;EAeA;IACE,WAAA;IACA,wBAAA;EAbF;AACF;AAgBA;EACE;IACE,WAAA;IACA,wBAAA;EAdF;EAiBA;IACE,WAAA;IACA,oBAAA;EAfF;EAkBA;IACE,MAAA;IACA,oBAAA;EAhBF;AACF;AAmBA;EACE;IACE,SAAA;IACA,oBAAA;EAjBF;EAoBA;IACE,cAAA;IACA,oBAAA;EAlBF;EAqBA;IACE,cAAA;IACA,yBAAA;EAnBF;AACF;AAsBA;EACE;IACE,cAAA;IACA,yBAAA;EApBF;EAuBA;IACE,cAAA;IACA,oBAAA;EArBF;EAwBA;IACE,SAAA;IACA,oBAAA;EAtBF;AACF;AAyBA;EACE;IACE,mBAAA;EAvBF;EA0BA;IACE,mBAAA;EAxBF;AACF;AA2BA;EACE;IACE,mBAAA;EAzBF;EA4BA;IACE,mBAAA;EA1BF;EA6BA;IACE,mBAAA;EA3BF;AACF;AEp7BE;EFo9BA;IACE,UAAA;EA7BF;EA+BA;IACE,cAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,eAAA;EA7BF;EAgCA;IACE,UAAA;IACA,WAAA;EA9BF;EAiCA;IACE,OAAA;IACA,QAAA;EA/BF;EAkCA;IACE,aAAA;EAhCF;EAmCA;IACE,WAAA;IACA,WAAA;IACA,8BAAA;IACA,iBAAA;IACA,qBAAA;IACA,UAAA;EAjCF;AACF;AE78BE;EFk/BA;IACE,aAAA;EAlCF;EAsCE;IACE,SAAA;EApCJ;EAsCI;IACE,qBAAA;IACA,sBAAA;EApCN;EAyCA;IACE,UAAA;IACA,WAAA;EAvCF;EA0CA;IACE,QAAA;EAxCF;EA2CA;IACE,cAAA;EAzCF;EA4CA;IACE,WAAA;IACA,YAAA;IACA,8BAAA;IACA,iBAAA;IACA,qBAAA;IACA,UAAA;EA1CF;EA6CA;;;IAGE,QAAA;EA3CF;EA8CA;;;IAGE,gBAAA;EA5CF;AACF;AE/+BE;EF+hCA;IACE,SAAA;EA7CF;EA+CE;IACE,SAAA;EA7CJ;EA+CI;IACE,WAAA;IACA,YAAA;EA7CN;EAkDA;IACE,aAAA;EAhDF;EAmDA;IACE,WAAA;IACA,YAAA;EAjDF;EAoDA;IACE,cAAA;EAlDF;EAqDA;IACE,WAAA;IACA,YAAA;IACA,8BAAA;IACA,iBAAA;IACA,qBAAA;IACA,UAAA;EAnDF;EAsDA;;;IAGE,QAAA;EApDF;EAuDA;;;IAGE,gBAAA;EArDF;EAwDA;IACE,QAAA;EAtDF;EAyDA;IACE,SAAA;EAvDF;AACF;AEvhCE;EFklCA;IACE,aAAA;EAxDF;EA2DA;IACE,WAAA;IACA,YAAA;EAzDF;EA4DA;IACE,cAAA;EA1DF;EA6DA;IACE,WAAA;IACA,YAAA;IACA,8BAAA;IACA,iBAAA;IACA,qBAAA;IACA,UAAA;EA3DF;EA8DA;;;IAGE,QAAA;EA5DF;EA+DA;;;IAGE,gBAAA;EA7DF;EAgEA;IACE,QAAA;EA9DF;EAiEA;IACE,SAAA;EA/DF;AACF","sourcesContent":["@import \"../../assets//scss/combined.scss\";\n\n.navigation {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 35em;\n\n  &_left {\n    // flex: 2;\n  }\n\n  &_logo {\n    & > img {\n      display: block;\n      width: 12em !important;\n      height: 12em !important;\n      position: absolute;\n      top: 0;\n      left: 0;\n      cursor: pointer;\n      /* background-color: white; */\n      text-align: center;\n    }\n  }\n\n  & > nav {\n    // flex: 2;\n  }\n\n  &_cart {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    text-align: end;\n    // flex: 1;\n    color: $bdt-gold;\n    font-size: 1.5em;\n    cursor: pointer;\n\n    &_count {\n      font-size: .5em;\n      position: absolute;\n      color: $bdt-white;\n      border: 1px solid $bdt-gold;\n      border-radius: 4px;\n      top: -16px;\n      right: -32px;\n      width: 2em;\n      padding: .2em;\n      text-align: center;\n    }\n  }\n}\n\nheader {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 115px;\n  z-index: 10;\n  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/123024/menutexture.png);\n  background-position: center top;\n  background-size: auto 200px;\n  background-repeat: repeat-x;\n}\nheader .inner {\n  max-width: 1060px;\n  margin: 0 auto;\n  display: flex;\n  height: 70px;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\nheader .logo {\n  display: block;\n  width: 12em !important;\n  height: 12em !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  /* background-color: white; */\n  text-align: center;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\nheader nav {\n  display: flex;\n  flex-direction: row;\n}\nheader nav a {\n  font-family: \"Varela Round\";\n  font-size: 12px;\n  color: #8c8c8e;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  text-decoration: none;\n  margin: 0 18px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  // justify-content: center;\n}\nheader nav a.active,\nheader nav a:hover {\n  color: white;\n}\n\nheader .burger {\n  display: block;\n  position: relative;\n  top: -6px;\n  padding-left: 30px;\n}\nheader .burger:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 30px;\n  height: 2px;\n  background: white;\n  box-shadow: 0 12px 0 0 white, 0 6px 0 0 white;\n}\n\nheader .donate-link {\n  width: 72px;\n  text-align: center;\n  position: absolute;\n  right: 10px;\n  top: 27px;\n  font-family: \"Varela Round\";\n  font-size: 12px;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  text-decoration: none;\n  padding-bottom: 6px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.3);\n}\n\n.mobileNav_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10em;\n}\n\n.mobileNav {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 70%;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  z-index: 999999 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2em;\n\n  a {\n\n    font-size: 1.5em;\n    text-transform: uppercase;\n    letter-spacing: 3px;\n    text-decoration: none;\n  }\n}\n\n@keyframes flickerL {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  100% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n    // opacity: 1;\n  }\n}\n@keyframes flickerO {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.66667% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  73.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  74% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  74.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  75.33333% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  75.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  94.44444% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerA {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.86667% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.88889% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerD {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.31111% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerI {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.75556% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerN {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.2% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerG {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.64444% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n#n {\n  position: absolute;\n  top: 90%;\n  left: -28%;\n  right: 0;\n  height: 5vw;\n  width: 20%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 15;\n}\n#n li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#n li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#n li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#n li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#n li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#n li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n#n li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 1.25s;\n  animation-duration: 4.5s;\n}\n#n li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n\n#a {\n  position: absolute;\n  top: 90%;\n  left: 2%;\n  right: 0%;\n  height: 5vw;\n  width: 20%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#a li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#a li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#a li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#a li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#a li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#a li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n#v {\n  position: absolute;\n  top: 90%;\n  left: 30%;\n  right: 0%;\n  height: 5vw;\n  width: 20%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#v li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#v li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#v li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#v li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#v li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#v li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n// Button for Menu\n/* <reset-style> ============================ */\nbutton {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  font-family: inherit;\n}\n/* ============================ */\n/* <style for bg> ======== */\n.background {\n  border-radius: 16px;\n  border: 1px solid #1a1a1a;\n  background: transparent;\n  border: 1px solid $bdt-gold;\n  // mix-blend-mode: overlay;\n  box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.20);\n  backdrop-filter: blur(15px);\n  width: 65px;\n  height: 65px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n  justify-self: center;\n  position: relative;\n  z-index: 10;\n}\n\n/* <style for menu__icon> ======== */\n.menu__icon {\n  width: 32px;\n  height: 32px;\n  padding: 4px;\n}\n\n.menu__icon span {\n  display: block;\n  width: 100%;\n  height: 0.125rem;\n  border-radius: 2px;\n  background-color: $bdt-gold;\n  box-shadow: 0 .5px 2px 0 hsla(0, 0%, 0%, .2);\n  transition: background-color .4s;\n  position: relative;\n}\n\n.menu__icon span+span {\n  margin-top: .375rem;\n}\n\n.menu__icon span:nth-child(1) {\n  animation: ease .8s menu-icon-top-2 forwards;\n}\n\n.menu__icon span:nth-child(2) {\n  animation: ease .8s menu-icon-scaled-2 forwards;\n}\n\n.menu__icon span:nth-child(3) {\n  animation: ease .8s menu-icon-bottom-2 forwards;\n}\n\n.menu__icon:hover span:nth-child(1) {\n  animation: ease .8s menu-icon-top forwards;\n}\n\n.menu__icon:hover span:nth-child(2) {\n  animation: ease .8s menu-icon-scaled forwards;\n}\n\n.menu__icon:hover span:nth-child(3) {\n  animation: ease .8s menu-icon-bottom forwards;\n  background-color: $bdt-black;\n}\n\n@keyframes menu-icon-top {\n  0% {\n    top: 0;\n    transform: rotate(0);\n  }\n\n  50% {\n    top: .5rem;\n    transform: rotate(0);\n  }\n\n  100% {\n    top: .5rem;\n    transform: rotate(45deg);\n  }\n}\n\n@keyframes menu-icon-top-2 {\n  0% {\n    top: .5rem;\n    transform: rotate(45deg);\n  }\n\n  50% {\n    top: .5rem;\n    transform: rotate(0);\n  }\n\n  100% {\n    top: 0;\n    transform: rotate(0);\n  }\n}\n\n@keyframes menu-icon-bottom {\n  0% {\n    bottom: 0;\n    transform: rotate(0);\n  }\n\n  50% {\n    bottom: .5rem;\n    transform: rotate(0);\n  }\n\n  100% {\n    bottom: .5rem;\n    transform: rotate(135deg);\n  }\n}\n\n@keyframes menu-icon-bottom-2 {\n  0% {\n    bottom: .5rem;\n    transform: rotate(135deg);\n  }\n\n  50% {\n    bottom: .5rem;\n    transform: rotate(0);\n  }\n\n  100% {\n    bottom: 0;\n    transform: rotate(0);\n  }\n}\n\n@keyframes menu-icon-scaled {\n  50% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n@keyframes menu-icon-scaled-2 {\n  0% {\n    transform: scale(0);\n  }\n\n  50% {\n    transform: scale(0);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n\n@include screen-sm {\n  .navigation {\n    gap: .5em;\n  }\n  header .burger {\n    display: block;\n    position: relative;\n    top: -6px;\n    right: -40%;\n    padding-left: 0;\n  }\n\n  header .logo img {\n    width: 3em;\n    height: 3em;\n  }\n\n  header .logo {\n    left: 0;\n    top: 10%;\n  }\n\n  .navigation_company {\n    display: none;\n  }\n\n  #slider img {\n    width: 10em;\n    height: 60%;\n    object-position: center center;\n    object-fit: cover;\n    image-rendering: auto;\n    z-index: 6;\n  }\n}\n\n@include screen-md {\n  header .burger {\n    display: none;\n  }\n\n  .navigation {\n    &_logo {\n      flex: 1;\n\n      & > img {\n        width: 5em !important;\n        height: 5em !important;\n      }\n    }\n  }\n\n  header .logo img {\n    width: 5em;\n    height: 5em;\n  }\n\n  header .logo {\n    left: 0%;\n  }\n\n  .navigation_company {\n    display: block;\n  }\n\n  #slider img {\n    width: 10em;\n    height: 100%;\n    object-position: center center;\n    object-fit: cover;\n    image-rendering: auto;\n    z-index: 6;\n  }\n\n  #n,\n  #a,\n  #v {\n    top: 70%;\n  }\n\n  #n li,\n  #a li,\n  #v li {\n    font-size: 1.2em;\n  }\n}\n\n@include screen-lg {\n  .navigation {\n    gap: 34em;\n\n    &_logo {\n      flex: 1;\n\n      & > img {\n        width: 12em;\n        height: 12em;\n      }\n    }\n  }\n\n  header .burger {\n    display: none;\n  }\n\n  header .logo img {\n    width: 100%;\n    height: 100%;\n  }\n\n  .navigation_company {\n    display: block;\n  }\n\n  #slider img {\n    width: 10em;\n    height: 100%;\n    object-position: center center;\n    object-fit: cover;\n    image-rendering: auto;\n    z-index: 6;\n  }\n\n  #n,\n  #a,\n  #v {\n    top: 70%;\n  }\n\n  #n li,\n  #a li,\n  #v li {\n    font-size: 1.8em;\n  }\n\n  #a {\n    left: 7%;\n  }\n\n  #v {\n    left: 40%;\n  }\n}\n\n@include screen-xl {\n  header .burger {\n    display: none;\n  }\n\n  header .logo img {\n    width: 100%;\n    height: 100%;\n  }\n\n  .navigation_company {\n    display: block;\n  }\n\n  #slider img {\n    width: 10em;\n    height: 100%;\n    object-position: center center;\n    object-fit: cover;\n    image-rendering: auto;\n    z-index: 6;\n  }\n\n  #n,\n  #a,\n  #v {\n    top: 90%;\n  }\n\n  #n li,\n  #a li,\n  #v li {\n    font-size: 1.5vw;\n  }\n\n  #a {\n    left: 2%;\n  }\n\n  #v {\n    left: 30%;\n  }\n}\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
